import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Title from "../general/title"
import ReactTable from "react-table"
import _ from "lodash"
import settings from "settings"
import { loadingStatus, getPayload } from "actions"
import axios from "axios"
import Modal from "react-responsive-modal"
import fieldStatus from "helpers/fieldStatus"
import submitData from "helpers/submitData"
import ReactSelect from "components/ReactSelect"
import { Formik, Field, Form } from "formik"
import { ToastContainer, toast } from "react-toastify"
import fields from "models/feed"
import FullTable from "components/FullTable"
import helpers from "helpers/helpers"

class BuilderFeeds extends Component {
	constructor(props) {
		super(props)

		this.state = {
			columns: [
				{
					Header: "ID",
					accessor: "id",
					filterMethod: (f, r) => helpers.tableText(f, r, "id"),
				},
				{
					Header: "Property",
					accessor: "property",
					filterMethod: (f, r) => helpers.tableText(f, r, "property"),
				},
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Lot Type",
					accessor: "lot_type",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
				},
				{
					Header: "Subdivision",
					accessor: "subdivision",
					filterMethod: (f, r) => helpers.tableText(f, r, "subdivision"),
				},
				{
					Header: "Sub Number",
					accessor: "subdivision_number",
					filterMethod: (f, r) => helpers.tableText(f, r, "subdivision_number"),
				},
				{
					Header: "Status",
					accessor: "status",
					filterMethod: (f, r) => helpers.tableText(f, r, "status"),
				},
				{
					Header: "Last Run",
					accessor: "last_run",
					filterable: false,
				},
				{
					Header: "Run",
					accessor: "run",
				},
				{
					Header: "Clone",
					accessor: "clone",
				},
				{
					Header: "Edit",
					accessor: "edit",
				},
			],
			filesColumns: [
				{
					Header: "ID",
					accessor: "id",
					filterMethod: (f, r) => helpers.tableText(f, r, "id"),
				},
				{
					Header: "Property",
					accessor: "property",
					filterMethod: (f, r) => helpers.tableText(f, r, "property"),
				},
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Lot Type",
					accessor: "lot_type",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
				},
				{
					Header: "Subdivision",
					accessor: "subdivision",
					filterMethod: (f, r) => helpers.tableText(f, r, "subdivision"),
				},
				{
					Header: "Sub Number",
					accessor: "subdivision_number",
					filterMethod: (f, r) => helpers.tableText(f, r, "subdivision_number"),
				},
				{
					Header: "Status",
					accessor: "status",
					filterMethod: (f, r) => helpers.tableText(f, r, "status"),
				},
				{
					Header: "Run",
					accessor: "run",
				},
				{
					Header: "Last Run",
					accessor: "last_run",
					filterable: false,
				},
			],
			data: {},
			editModal: false,
			editData: {},
			addModal: false,
			filtered: [],
			filteredFiles: [],
			lotTypes: "",
		}
	}

	componentDidMount() {
		this.getData()
	}

	getData = () => {
		this.props.loadingStatus(true)
		let userToken = localStorage.getItem("user")
		axios
			.post(
				settings.ep + "/getBuilderFeeds",
				{
					properties: this.props.activeProperties,
				},
				{ headers: { Authorization: `Bearer ${userToken}` } }
			)
			.then((resp) => {
				if (resp.data.status == 400) {
					this.setState({ data: [] }, () => this.props.loadingStatus(false))
					this.props.loadingStatus(false)
				} else if (resp.status == 200) {
					this.setState(
						{
							data: resp.data.data,
						},
						() => {
							this.props.loadingStatus(false)
						}
					)
				} else {
					this.setState({ data: [] }, () => this.props.loadingStatus(false))
				}
			})
	}

	buildTable = () => {
		let data = []
		_.forEach(this.state.data.urls, (v) => {
			if (this.props.activeProperties?.length && !this.props.activeProperties.includes(v.property)) {
				return
			}
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			let property = _.find(this.props.payload.public.properties, { id: v.property })
			let p = {}
			p.property = property ? property.name : ""
			p.builder = builder ? builder.name : ""
			p.lot_type = type ? type.name : ""
			p.subdivision = v.xml_subdivision
			p.id = v.id
			p.subdivision_number = v.xml_subdivision_number
			p.status = v.status ? "Enabled" : "Disabled"
			p.run = (
				<i
					className="far fa-rotate blue cursor-pointer"
					onClick={() => {
						this.props.loadingStatus(true)
						submitData("mainIngest", { type: "url", id: v.id, action: "reRunFeed" })
							.then(async (data) => {
								toast.success(data.message)
								await this.props.getPayload()
								this.props.loadingStatus(false)
							})
							.catch((e) => {
								toast.error(`Could not run feed.  Please try again later.`)
								this.props.loadingStatus(false)
								console.log(e)
							})
					}}></i>
			)
			p.clone = (
				<i
					className="far fa-clone blue cursor-pointer"
					onClick={() => {
						this.props.loadingStatus(true)
						submitData("mainIngest", { type: "url", id: v.id, action: "cloneFeed" })
							.then(async (data) => {
								toast.success(data.message)
								this.getData()
								this.props.loadingStatus(false)
							})
							.catch((e) => {
								toast.error(`Could not clone feed.  Please try again later.`)
								this.props.loadingStatus(false)
								console.log(e)
							})
					}}></i>
			)
			p.edit = <i className="far fa-edit" onClick={() => this.setState({ editModal: true, editData: v })}></i>
			p.last_run = v.last_run ? (
				<i className="fas fa-check-circle green"></i>
			) : (
				<i className="fas fa-times-circle red"></i>
			)
			data.push(p)
		})
		return data
	}

	buildFilesTable = () => {
		let data = []
		_.forEach(this.state.data.files, (v) => {
			if (!this.props.activeProperties.includes(v.property)) {
				return
			}
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			let property = _.find(this.props.payload.public.properties, { id: v.property })
			let p = {}
			p.property = property ? property.name : ""
			p.builder = builder ? builder.name : ""
			p.lot_type = type ? type.name : ""
			p.id = v.id
			p.subdivision = v.xml_subdivision
			p.subdivision_number = v.xml_subdivision_number
			p.status = v.status ? "Enabled" : "Disabled"
			p.run = (
				<i
					className="far fa-rotate blue cursor-pointer"
					onClick={() => {
						this.props.loadingStatus(true)
						submitData("mainIngest", { type: "file", id: v.id, action: "reRunFeed" })
							.then(async (data) => {
								toast.success(data.message)
								await this.props.getPayload()
								this.props.loadingStatus(false)
							})
							.catch((e) => {
								toast.error(`Could not run feed.  Please try again later.`)
								this.props.loadingStatus(false)
								console.log(e)
							})
					}}></i>
			)
			p.last_run = v.last_run ? (
				<i className="fas fa-check-circle green"></i>
			) : (
				<i className="fas fa-times-circle red"></i>
			)
			data.push(p)
		})
		return data
	}

	submitClasses = (f) => {
		var classNames = require("classnames")
		var submitClasses = classNames("form__submit", {
			"form__submit--ready": f,
		})

		return submitClasses
	}

	options = (f, name) => {
		let ret = []
		this.props.payload.public[name].forEach((v) => {
			if (f.values.property && f.values.property == v.property) {
				ret.push({ label: v.name, value: v.id })
			}
		})

		ret = _.sortBy(ret, "label")
		return ret
	}

	buildLotTypes = (property, builder) => {
		let lotTypes = []
		_.forEach(this.props.payload.exec.lots, (v) => {
			if (v.property === property && v.builder === builder) {
				let lt = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
				if (lt && !lotTypes.includes(lt.name)) {
					lotTypes.push(lt.name)
				}
			}
		})
		lotTypes = _.sortBy(lotTypes, (v) => v.toLowerCase())
		lotTypes = lotTypes.join(", ")
		this.setState({ lotTypes })
	}

	render() {
		if (this.props.payloadStatus) {
			return (
				<div className="admin">
					<Title title="Builder Feeds" showDate={false} />
					<div className="content">
						<h2>Feed URLs</h2>
						<div className="admin__add">
							<i className="fas fa-plus-circle" onClick={() => this.setState({ addModal: true })} />
						</div>
						<FullTable
							data={this.buildTable()}
							columns={this.state.columns}
							name="builderFeedUrls"
							title="BuilderFeedURLs"
							unset={["edit"]}
							pageSize={20}
							defaultSorted={[
								{
									id: "status",
									desc: true,
								},
							]}
						/>
					</div>
					<div className="content">
						<h2>Feed Files</h2>
						<p className="small mt-2">
							Due to the nature of builder file dropoff, Feed files are not editable in Pipsy. Please
							contact Pipsy support to maintain feed files.
						</p>
						<FullTable
							data={this.buildFilesTable()}
							columns={this.state.filesColumns}
							name="builderFeedFiles"
							title="BuilderFeedFiles"
							unset={["edit"]}
							pageSize={20}
							defaultSorted={[
								{
									id: "status",
									desc: true,
								},
							]}
						/>
					</div>
					<Modal
						name="editFeed"
						classNames={{ modal: "modalForm" }}
						open={this.state.editModal}
						onClose={() => this.setState({ editModal: false, lotTypes: "" })}
						center>
						<h2>Edit Feed</h2>
						{this.state.lotTypes && (
							<div className="mt-4 text-sm text-blue">Types: {this.state.lotTypes}</div>
						)}
						<Formik
							initialValues={this.state.editData}
							onSubmit={(values) => {
								this.props.loadingStatus(true)
								submitData("editFeed", values)
									.then((data) => {
										toast.success(data.message)
										this.setState({ editModal: false, editData: {} }, () => {
											this.props.loadingStatus(false)
											this.getData()
										})
									})
									.catch((e) => {
										toast.success(`Could not edit feed.  Please try again later.`)
										this.props.loadingStatus(false)
										console.log(e)
									})
							}}
							render={(f) => (
								<div>
									{/* console.log(f) */}
									<Form>
										<ul className="modalForm__list">
											<li className={fieldStatus("property", f)}>
												<label htmlFor="property">
													Property <sup>*</sup>
												</label>
												{f.errors.property && f.touched.property && (
													<div className="form__message">{f.errors.property}</div>
												)}
												<ReactSelect
													name={`property`}
													options={_.map(this.props.payload.public.properties, (v) => {
														return { value: v.id, label: v.name }
													})}
													value={f.values.property}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("builder", f)}>
												<label htmlFor="builder">
													Builder <sup>*</sup>
												</label>
												{f.errors.builder && f.touched.builder && (
													<div className="form__message">{f.errors.builder}</div>
												)}
												<ReactSelect
													name={`builder`}
													options={_.map(this.props.payload.public.builders, (v) => {
														return { value: v.id, label: v.name }
													})}
													value={f.values.builder}
													onBlur={f.setFieldTouched}
													onChange={(k, v) => {
														f.setFieldValue("builder", v)
														this.buildLotTypes(f.values.property, v)
													}}
												/>
											</li>
											<li className={fieldStatus("lot_type", f)}>
												<label htmlFor="lot_type">Default Lot Type</label>
												{f.errors.lot_type && f.touched.lot_type && (
													<div className="form__message">{f.errors.lot_type}</div>
												)}
												<ReactSelect
													name={`lot_type`}
													options={this.options(f, "lot_types")}
													value={f.values.lot_type}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("feed", f)}>
												<label htmlFor="feed">Feed URL</label>
												{f.errors.feed && f.touched.feed && (
													<div className="form__message">{f.errors.feed}</div>
												)}
												<Field name="feed" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("xml_subdivision", f)}>
												<label htmlFor="xml_subdivision">Subdivision Name</label>
												{f.errors.xml_subdivision && f.touched.xml_subdivision && (
													<div className="form__message">{f.errors.xml_subdivision}</div>
												)}
												<Field name="xml_subdivision" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("xml_subdivision_number", f)}>
												<label htmlFor="xml_subdivision_number">Feed Sub Number</label>
												{f.errors.xml_subdivision_number &&
													f.touched.xml_subdivision_number && (
														<div className="form__message">
															{f.errors.xml_subdivision_number}
														</div>
													)}
												<Field
													name="xml_subdivision_number"
													type="text"
													className="form__input"
												/>
											</li>
											<li className={fieldStatus("status", f)}>
												<label htmlFor="status">Status</label>
												{f.errors.status && f.touched.status && (
													<div className="form__message">{f.errors.status}</div>
												)}
												<ReactSelect
													name={`status`}
													options={[
														{
															label: "Disabled",
															value: 0,
														},
														{
															label: "Enabled",
															value: 1,
														},
													]}
													value={f.values.status}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
										</ul>
										<input type="submit" value="Submit" className={this.submitClasses(f.isValid)} />
									</Form>
								</div>
							)}
						/>
					</Modal>
					<Modal
						name="addFeed"
						classNames={{ modal: "modalForm" }}
						open={this.state.addModal}
						onClose={() => this.setState({ addModal: false, lotTypes: "" })}
						center>
						<h2>Add Feed</h2>
						{this.state.lotTypes && (
							<div className="mt-4 text-sm text-blue">Types: {this.state.lotTypes}</div>
						)}
						<Formik
							initialValues={fields}
							onSubmit={(values) => {
								this.props.loadingStatus(true)
								submitData("addFeed", values)
									.then((data) => {
										toast.success(data.message)
										this.setState({ addModal: false }, () => {
											this.props.loadingStatus(false)
											this.getData()
										})
									})
									.catch((e) => {
										toast.success(`Could not edit feed.  Please try again later.`)
										this.props.loadingStatus(false)
										console.log(e)
									})
							}}
							render={(f) => (
								<div>
									{/* console.log(f) */}
									<Form>
										<ul className="modalForm__list">
											<li className={fieldStatus("property", f)}>
												<label htmlFor="property">
													Property <sup>*</sup>
												</label>
												{f.errors.property && f.touched.property && (
													<div className="form__message">{f.errors.property}</div>
												)}
												<ReactSelect
													name={`property`}
													options={_.map(this.props.payload.public.properties, (v) => {
														return { value: v.id, label: v.name }
													})}
													value={f.values.property}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("builder", f)}>
												<label htmlFor="builder">
													Builder <sup>*</sup>
												</label>
												{f.errors.builder && f.touched.builder && (
													<div className="form__message">{f.errors.builder}</div>
												)}
												<ReactSelect
													name={`builder`}
													options={_.map(this.props.payload.public.builders, (v) => {
														return { value: v.id, label: v.name }
													})}
													value={f.values.builder}
													onBlur={f.setFieldTouched}
													onChange={(k, v) => {
														f.setFieldValue("builder", v)
														this.buildLotTypes(f.values.property, v)
													}}
												/>
											</li>
											<li className={fieldStatus("lot_type", f)}>
												<label htmlFor="lot_type">Default Lot Type</label>
												{f.errors.lot_type && f.touched.lot_type && (
													<div className="form__message">{f.errors.lot_type}</div>
												)}
												<ReactSelect
													name={`lot_type`}
													options={this.options(f, "lot_types")}
													value={f.values.lot_type}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("feed", f)}>
												<label htmlFor="feed">Feed URL</label>
												{f.errors.feed && f.touched.feed && (
													<div className="form__message">{f.errors.feed}</div>
												)}
												<Field name="feed" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("xml_subdivision", f)}>
												<label htmlFor="xml_subdivision">Subdivision Name</label>
												{f.errors.xml_subdivision && f.touched.xml_subdivision && (
													<div className="form__message">{f.errors.xml_subdivision}</div>
												)}
												<Field name="xml_subdivision" type="text" className="form__input" />
											</li>
											<li className={fieldStatus("xml_subdivision_number", f)}>
												<label htmlFor="xml_subdivision_number">Feed Sub Number</label>
												{f.errors.xml_subdivision_number &&
													f.touched.xml_subdivision_number && (
														<div className="form__message">
															{f.errors.xml_subdivision_number}
														</div>
													)}
												<Field
													name="xml_subdivision_number"
													type="text"
													className="form__input"
												/>
											</li>
											<li className={fieldStatus("status", f)}>
												<label htmlFor="status">Status</label>
												{f.errors.status && f.touched.status && (
													<div className="form__message">{f.errors.status}</div>
												)}
												<ReactSelect
													name={`status`}
													options={[
														{
															label: "Disabled",
															value: 0,
														},
														{
															label: "Enabled",
															value: 1,
														},
													]}
													value={f.values.status}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
										</ul>
										<input type="submit" value="Submit" className={this.submitClasses(f.isValid)} />
									</Form>
								</div>
							)}
						/>
					</Modal>
				</div>
			)
		} else {
			return ""
		}
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({ loadingStatus, getPayload }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(BuilderFeeds)
